export const defaultDataModal = {
  open: false,
  title: '',
  component: '',
  params: {}
}

export const defaultDataNewProduct = {
  name: '',
  description: '',
  price: '',
  stock: '',
  idCategory: '',
  image: ''
}
